import REGISTER from "../assets/images/register.png";
import Checkbox from "antd/es/checkbox/Checkbox";
import { NavLink, useHistory } from "react-router-dom";
import { useState } from "react";
import $ from 'jquery';
import { toast } from "react-toastify";
import { Eye, EyeOff } from "react-feather";
import API_LINK from "../components/links/Link";
import { Radio, Select } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { BiEnvelope, BiLogoFacebook, BiLogoInstagram, BiLogoLinkedin, BiMenu, BiX } from "react-icons/bi";
import { BACKGROUND, LOGO } from "./assets/images/Images";
export default function ForgotPassword() {
    const [isVisible, setIsVisible] = useState(false)
    const history = useHistory();
    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $('.RegisterForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else if (!form.find('input[name="email"]').val().includes("@")) {
            toast.warn("Please enter a valid email address");
        } else {
            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "ForgotPasswordMail");
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                await fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                toast.update(toaster, {
                                    type: "success",
                                    render: "An account reset email has been sent to your provided email address.",
                                    isLoading: false,
                                    autoClose: toaster,
                                    closeButton: true,
                                    pauseOnHover: false,
                                    pauseOnFocusLoss: false,
                                })
                                // toast.info("We have shared a verification email.Please make sure to verify your account.");
                                form.find("button").attr("disabled", false);
                                form.trigger("reset");
                                // history.push("/");
                            }, 1000)
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }

    }

    return (
        <>
            <div className='auth-container' style={{ justifyContent: "center" }}>


                <div className="topbar-container">
                    <ul className={'social-list'}>
                        <li>
                            <a href="mailto:info@1solardirect.com">
                                <BiEnvelope />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/1Solardirect/">
                                <BiLogoFacebook />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/1solardirect/">
                                <BiLogoInstagram />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/1-solar-direct/about/">
                                <BiLogoLinkedin />
                            </a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Contact Us</a>
                        </li>
                        <li>
                            <a href="https://1solardirect.com/contact-us/">Get Your Quote</a>
                        </li>
                        <li>
                            <a href="mailto:info@1solardirect.com">Quick Help</a>
                        </li>
                    </ul>
                </div>
                <div className="menu-container">
                    <a href="https://1solardirect.com/">
                        <img src={LOGO} alt="Company Logo" className="logo" />
                    </a>
                    <button className="hamburger-menu" onClick={() => {
                        document.getElementById('menu').classList.toggle('show');
                    }}>
                        <BiMenu />
                    </button>
                    <div className="menu" id={'menu'}>
                        <button className="hamburger-menu hamburger-menu-close" onClick={() => {
                            document.getElementById('menu').classList.toggle('show');
                        }}>
                            <BiX />
                        </button>
                        <ul className="navlist">
                        <li>
                                <a href="https://1solardirect.com/">Home</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/about-us/">About Us</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/check-inventory/">Check Inventory</a>
                            </li>
                            <li>
                                <a href="https://1solardirect.com/our-products/">Our Products</a>
                            </li>
                        </ul>
                        <a href="https://dashboard.1solardirect.com/" className={'menu-btn'}>Login / Register</a>
                    </div>
                </div>

                <style>
                    {`
    .navlist a {
      color: #000 !important;
      text-decoration: none;
      transition: color 0.3s ease-in-out;
    }

    .navlist a:hover {
      color: #F99F1D !important;
    }

    /* Ensure styling applies on mobile as well */
    @media (max-width: 768px) {
      .navlist a {
        color: white !important;
      }

      .navlist a:hover {
        color: #F99F1D !important;
      }
    }
  `}
                </style>
                {/*<div className="auth-image">*/}
                {/*    <img src={REGISTER} loading={"lazy"} alt="Login Image"/>*/}
                {/*</div>*/}
                <div className="auth-form register-form-container" data-aos='fade-left'>
                    <h4 className="title" style={{ marginTop: 50, textAlign: "center" }}>Password Reset</h4>
                    <div className="header_text_center">
                        <p style={{ fontSize: 14, marginBottom: 30, textAlign: "center" }}>Please enter your email
                            address.
                            You will receive a link to create a new password via email.</p>
                    </div>
                    <form noValidate className='RegisterForm' onSubmit={submitHandle}>
                        <div className="register-form">
                            <div className="form-group">
                                {/*<label>Email address <code>*</code></label>*/}
                                <input type="text" required placeholder={'Email Address*'} name={'email'} />
                            </div>
                        </div>
                        <div className="form-group">
                            <button type={"submit"} className='btn-login'>Get New Password</button>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}
